import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe, PercentPipe } from '@angular/common';
import { RouterModule } from '@angular/router';

// Components
import { GoBackComponent } from './components/go-back/go-back.component';

// Formulario
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// NGX BOOTSTRAP
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { BsDatepickerModule, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { AlertModule } from 'ngx-bootstrap/alert';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { SortableModule } from 'ngx-bootstrap/sortable';

// Slick carousel
import { SlickCarouselModule } from 'ngx-slick-carousel';

// PIPE
import { StringToDatePipe } from './pipes/string-to-date.pipe';
import { NumbersFormatPipe } from './pipes/numbers-format.pipe';
import { TiresiaToDatePipe } from './pipes/tiresia-to-date.pipe';
import { LoadingComponent } from './components/loading/loading.component';
import { SafePipe } from './pipes/safepipe.pipe';
import { SafeHTMLPipe } from './pipes/safe-html.pipe';

// NG Select
import { NgSelectModule } from '@ng-select/ng-select';
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';

// NGX Bootstrap DatePicker, config y lenguaje
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale } from 'ngx-bootstrap/locale';
defineLocale('es', esLocale);

//QR
import { QRCodeModule } from 'angularx-qrcode';

import { NgxFileDropModule } from 'ngx-file-drop';

// Directives
// import { ShowPasswordDirective } from './directives/show-password.directive';

import { ShowLoadingComponent } from './components/show-loading/show-loading.component';
import { SpaceDashPipe } from './pipes/space-dash.pipe';
import { CloudinaryTransfPipe } from './pipes/cloudinary-transf.pipe';
import { ImageFileSelectorComponent } from './components/image-file-selector/image-file-selector.component';
import { DateToTimeHmPipe } from './pipes/date-to-time-hm.pipe';
import { CurrencyFormatterDirective } from './directives/currency-formatter.directive';
import { PluckPipe } from './pipes/pluck.pipe';
import { AnyFileSelectorComponent } from './components/any-file-selector/any-file-selector.component';
import { CurrencyCOPPipe } from './pipes/currency-cop.pipe';
import { JefeDirectoAusentismoComponent } from './components/jefe-directo-ausentismo/jefe-directo-ausentismo.component';
import { BannerComponent } from './components/banner/banner.component';
import { StructureCreateComponent } from './components/structure-create/structure-create.component';
import { StructureReadingComponent } from './components/structure-reading/structure-reading.component';


@NgModule({
  declarations: [
    StringToDatePipe,
    // ShowPasswordDirective,
    GoBackComponent,
    LoadingComponent,
    TiresiaToDatePipe,
    NumbersFormatPipe,
    SafePipe,
    ShowLoadingComponent,
    SafeHTMLPipe,
    SpaceDashPipe,
    CloudinaryTransfPipe,
    ImageFileSelectorComponent,
    DateToTimeHmPipe,
    CurrencyFormatterDirective,
    PluckPipe,
    AnyFileSelectorComponent,
    CurrencyCOPPipe,
    JefeDirectoAusentismoComponent,
    BannerComponent,
    StructureCreateComponent,
    StructureReadingComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    QRCodeModule,
    NgOptionHighlightModule,
    PopoverModule.forRoot(),
    AccordionModule.forRoot(),
    PaginationModule.forRoot(),
    TimepickerModule.forRoot(),
    BsDatepickerModule.forRoot(),
    SortableModule.forRoot(),
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    CarouselModule.forRoot(),
    TypeaheadModule.forRoot(),
    CollapseModule.forRoot(),
    AlertModule.forRoot(),
    ButtonsModule.forRoot(),
    SlickCarouselModule,
    NgxFileDropModule
  ],
  exports: [
    // COMPONENTS
    GoBackComponent,
    QRCodeModule,
    LoadingComponent,
    ShowLoadingComponent,
    ImageFileSelectorComponent,
    AnyFileSelectorComponent,
    JefeDirectoAusentismoComponent,
    BannerComponent,
    StructureCreateComponent,
    StructureReadingComponent,
    // PIPE
    PluckPipe,
    StringToDatePipe,
    TiresiaToDatePipe,
    NumbersFormatPipe,
    SafeHTMLPipe,
    SpaceDashPipe,
    CloudinaryTransfPipe,
    SafePipe,
    DateToTimeHmPipe,
    CurrencyCOPPipe,
    // FORMS
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgOptionHighlightModule,
    // NGX BOOTSTRAP
    PaginationModule,
    TimepickerModule,
    SortableModule,
    BsDatepickerModule,
    ModalModule,
    AccordionModule,
    TooltipModule,
    CarouselModule,
    SlickCarouselModule,
    TypeaheadModule,
    CollapseModule,
    AlertModule,
    ButtonsModule,
    PopoverModule,
    // DIRECTIVES
    CurrencyFormatterDirective,
    NgxFileDropModule,
    StructureCreateComponent
    // ShowPasswordDirective,
  ],
  providers: [DecimalPipe, PercentPipe],
})
export class SharedModule {
  /**
   * @param localeService Servicio de ngx-bootstrap para setear lenguaje
   */
  constructor(private localeService: BsLocaleService) {
    this.localeService.use('es');
    esLocale.invalidDate = 'Fecha inválida';
  }
}
